import { useQuery } from '@tanstack/react-query'
import { httpGetRoadmapPermissions } from '@/features/roadmaps/http/roadmap.http'
import { QUERY_KEYS } from '@/query-client'

/**
 * Whether the current user may write to the roadmap. Drives which UI is shown;
 * the real gate is the backend, which rejects a write from anyone off the
 * allowlist regardless of what the client renders.
 */
export const useGetRoadmapPermissions = () =>
	useQuery({
		queryKey: [QUERY_KEYS.GET_ROADMAP_PERMISSIONS],
		queryFn: httpGetRoadmapPermissions
	})
